import { Tabs, Typography, Breadcrumb } from 'antd'
import { UploadOutlined, LinkOutlined, UnorderedListOutlined, MedicineBoxOutlined, TableOutlined, FileZipOutlined } from '@ant-design/icons'
import UploadStructure from './UploadStructure'
import FilialBinding from './FilialBinding'
import CurrentStructure from './CurrentStructure'
import UploadBedFund from './UploadBedFund'
import BedFundView from './BedFundView'
import FileIntake from './FileIntake'

const { Title } = Typography

interface ETLPageProps {
  initialTab?: string
}

export default function ETLPage({ initialTab = 'structure' }: ETLPageProps) {
  const items = [
    {
      key: 'structure',
      label: (
        <span>
          <UploadOutlined />
          Загрузка структуры
        </span>
      ),
      children: <UploadStructure />,
    },
    {
      key: 'binding',
      label: (
        <span>
          <LinkOutlined />
          Привязка филиалов
        </span>
      ),
      children: <FilialBinding />,
    },
    {
      key: 'current',
      label: (
        <span>
          <UnorderedListOutlined />
          Текущая структура
        </span>
      ),
      children: <CurrentStructure />,
    },
    {
      key: 'bed-fund-upload',
      label: (
        <span>
          <MedicineBoxOutlined />
          Загрузка КФ
        </span>
      ),
      children: <UploadBedFund />,
    },
    {
      key: 'bed-fund-view',
      label: (
        <span>
          <TableOutlined />
          Коечный фонд
        </span>
      ),
      children: <BedFundView />,
    },
    {
      key: 'file-intake',
      label: (
        <span>
          <FileZipOutlined />
          Файлы реестров
        </span>
      ),
      children: <FileIntake />,
    },
  ]

  return (
    <div>
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>Оргструктура и реквизиты</Breadcrumb.Item>
        <Breadcrumb.Item>Структура отделений</Breadcrumb.Item>
      </Breadcrumb>

      <Title level={2}>Структура отделений и коечный фонд</Title>

      <Tabs
        defaultActiveKey={initialTab}
        items={items}
        style={{ marginTop: 24 }}
      />
    </div>
  )
}
